import Box from '@mui/material/Box';
import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';

import { CheckIcon } from '../icons';

const BoxIcon = styled(Box)({
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: '1px solid #9AB1C0',
  borderRadius: 3,
  height: 16,
  justifyContent: 'center',
  width: 16,
  textAlign: 'center',
});

const StyledCheckbox = styled(MuiCheckbox)({
  ':hover': { backgroundColor: 'transparent' },
});

export const Checkbox = (props: CheckboxProps) => (
  <StyledCheckbox
    {...props}
    checkedIcon={
      <>
        <BoxIcon />
        <Box
          sx={{
            position: 'absolute',
            maxHeight: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CheckIcon stroke="#356482" sx={{ fontSize: 8 }} />
        </Box>
      </>
    }
    icon={<BoxIcon />}
  />
);
